module.exports = __webpack_public_path__ + "static/media/functionality.418f9c8f.jpeg";